import { useMutation } from '@tanstack/react-query';

import { uploadFileToS3 } from '@/helpers';
import { useApiMutation, useApiQuery, useFetch } from '@/modules/common';

import { OverlayItem, OverlayUploadUrlData } from '../types';

export function useOverlayDetails(maskId: string) {
  const fetchClient = useFetch();

  const uploadUrlDataMutation = useMutation<
    OverlayUploadUrlData & { file: File },
    undefined,
    { file: File }
  >({
    mutationFn: async ({ file }) => {
      const res = await fetchClient(`/overlays/reupload-url/${maskId}`, {
        method: 'GET',
      });
      return { ...res, file };
    },
    onSuccess: async ({ imageUploadUrl, file }) => {
      await uploadFileToS3({
        file,
        uploadUrl: imageUploadUrl,
      });
    },
  });

  const { isFetching, data, refetch } = useApiQuery<OverlayItem>(
    `/overlays/${maskId}`,
    {
      queryKey: ['overlayDetails', maskId],
      initialData: null,
      enabled: !!maskId,
    }
  );

  const updateOverlayMutation = useApiMutation<OverlayItem>(
    '/overlays',
    {
      method: 'PATCH',
    },
    {
      onSuccess: () => {
        refetch();
      },
    }
  );

  return {
    isFetching,
    uploadUrlDataMutation,
    details: data,
    updateOverlayMutation,
  } as const;
}
